// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__33_va"};